import {Injectable} from '@angular/core';
import BandwidthModel from '../../../models/bandwidth.model';
import {EventTrackingService} from './event-tracking.service';
import {EventEnum} from '../../../enums/event.enum';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BandwidthService {

    private data: BandwidthModel;
    private readonly bandwidthFailure = -1
    public testFilePath = '/assets/img/bandwidth/200k.jpg';

    constructor(
        private http: HttpClient,
        private tracking: EventTrackingService
    ) {}

    get kbps(): number {
        return this.data
            ? this.data.bandwidth === this.bandwidthFailure
                ? this.bandwidthFailure
                : Math.round(this.data.bandwidth / 1024)
            : 0;
    }

    get mbps(): number {
        return this.data
            ? this.data.bandwidth === this.bandwidthFailure
                ? this.bandwidthFailure
                : Math.round(this.data.bandwidth / 1024 / 1024)
            : 0;
    }

    public async detect() {
        try {
            this.data = await this.downloadFile();
        } catch {
            console.log('Could not get bandwidth due to a network error. Supplying with default value')
            this.data =  {
                testFileTime: this.bandwidthFailure,
                testFileSize: this.bandwidthFailure,
                bandwidth: this.bandwidthFailure
            }
        }
    }

    private getTestFile() {
        const version = (window as any).videoPlayerVersion;

        return environment.assetsCdnUrl
      + (version ? `/${version}` : '')
      + this.testFilePath;
    }

    protected downloadFile(): Promise<BandwidthModel> {
        return new Promise((resolve, reject) => {
            const startTime = this.now();
            const cacheBuster = '?cb=' + startTime;

            this.http.get(this.getTestFile(), {
                responseType: 'blob'
            })
                .subscribe(
                    response => {
                        const time = this.now() - startTime;
                        const data = {
                            testFileTime: time,
                            testFileSize: response.size,
                            bandwidth: this.calculateBandwidth(response.size, time)
                        };

                        this.tracking.track(EventEnum.Bandwidth, data);

                        resolve(data);
                    },
                    error => reject(Error('Network error'))
                );
        });
    }

    public calculateBandwidth(size, time): number {
        const sizeInBytes = size * 8;
        const timeInSeconds = time / 1000;

        return Math.floor(sizeInBytes / timeInSeconds);
    }

    private now() {
        return (new Date()).getTime();
    }
}
